<template>
  <div id="subscription">
    <h2>プレミアムユーザーになりましょう</h2>
    <hr>
    <div v-show="loading" class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    <div v-show="result">
      <div v-show="success">
        <p>プレミアム会員になりました😃</p>
        <p>5秒後にTOPページへ移動します</p>
      </div>
      <div v-show="!success">
        <p class="has-text-danger">決済に失敗しました...🙏</p>
      </div>
    </div>
    <div v-show="!loading && main">
      <vue-stripe-checkout
        ref="checkoutRef"
        :image="checkoutOptions.image"
        :name="checkoutOptions.name"
        :description="checkoutOptions.description"
        :currency="checkoutOptions.currency"
        :amount="checkoutOptions.amount"
        :allow-remember-me="true"
        :locale="checkoutOptions.locale"
        @done="done"
        @opened="opened"
        @closed="closed"
        @canceled="canceled"></vue-stripe-checkout>
      <button @click="checkoutMonth" class="button is-success">月額300円 by Stripe</button>
      <button @click="checkoutYear" class="button is-primary">年額3000円 by Stripe</button>
      <p class="info">画面が切り替わるまで操作をしないでください🙅<br>
        メールアドレスは、このサービスに登録しているメールアドレスと同じものにしてください👍</p>
      <div class="tile is-ancestor">
        <div class="tile is-parent">
          <article class="tile is-child box">
            <p class="title">1ファイル容量の制限緩和</p>
            <div class="content">
              <p>無料会員は1ファイル最大20MBまでですが、プレミアム会員では1ファイル<b>最大5GB！</b>まで対応してます。</p>
            </div>
          </article>
        </div>
        <div class="tile is-parent">
          <article class="tile is-child box">
            <p class="title">同時アップロード数の無制限</p>
            <div class="content">
              <p>無料会員は同時に3ファイルまでしかアップロードできませんが、プレミアム会員では<b>無制限</b>です。</p>
            </div>
          </article>
        </div>
      </div>
      <div class="tile is-ancestor">
        <div class="tile is-parent">
          <article class="tile is-child box">
            <p class="title">ファイルの種類は何でもOK</p>
            <div class="content">
              <p>無料会員はアップロードできるファイルの種類に制限がありますが、プレミアム会員では<b>どんなファイルもアップロード可能</b>です。</p>
            </div>
          </article>
        </div>
        <div class="tile is-parent">
          <article class="tile is-child box">
            <p class="title">画像の品質はそのままに</p>
            <div class="content">
              <p>無料会員は画像の圧縮がありますが、プレミアム会員では<b>そのままの画質</b>を利用できます。</p>
            </div>
          </article>
        </div>
      </div>
      <div class="tile is-ancestor">
        <div class="tile is-parent">
          <article class="tile is-child box">
            <p class="title">キャンセルはとても簡単</p>
            <div class="content">
              <p>ログインした状態で<router-link to="/unsubscription">こちら</router-link>から可能です。</p>
            </div>
          </article>
        </div>
        <div class="tile is-parent">
          <article class="tile is-child box">
            <p class="title">毎月300円 or 年額3000円の定額課金</p>
            <div class="content">
              <p>どんなにファイルをアップロードしても請求額は変わりません。決済には<a href="https://stripe.com/jp" title="Stripe">Stripe</a>を使用しています。</p>
            </div>
          </article>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Subscription',
  data: function () {
    return {
      main: true,
      loading: false,
      result: false,
      success: false,
      checkoutOptions: {
        image: '/static/images/favicon/icon-152x152.png',
        name: 'EasyUploader',
        description: '月額300円',
        currency: 'JPY',
        amount: 300,
        locale: 'ja'
      }
    }
  },
  methods: {
    async checkoutMonth () {
      this.main = false
      this.loading = true
      this.checkoutOptions.amount = 300
      this.checkoutOptions.description = '月額300円'
      await this.$refs.checkoutRef.open()
    },
    async checkoutYear () {
      this.main = false
      this.loading = true
      this.checkoutOptions.amount = 3000
      this.checkoutOptions.description = '年額3000円'
      await this.$refs.checkoutRef.open()
    },
    done (token, args) {
      let url = ''
      if (this.checkoutOptions.amount === 300) {
        url = this.baseURL + '/subscription?type=month'
      } else {
        url = this.baseURL + '/subscription?type=year'
      }

      this.$axios.post(url, {
        email: token.token.email,
        token: token.token.id
      }, { withCredentials: true })
        .then(response => {
          this.loading = false
          this.result = true
          this.success = true

          function top () {
            location.href = '/'
          }
          setTimeout(top, 5000)
        }).catch(() => {
          this.loading = false
          this.result = true
        })
    },
    opened () {
      // do stuff
    },
    closed () {
      this.main = true
      this.loading = false
    },
    canceled () {
      this.main = true
      this.loading = false
    }
  }
}
</script>

<style scoped>
  .info {
    font-weight: bold;
    font-size: small;
    color: red;
  }
  .title {
    font-size: 1.3rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/Subscription.vue